import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Auth0ProviderWithNavigate } from './auth/Auth0Provider';
import { AuthTokenSync } from './auth/AuthTokenSync';
import { AuthProvider, useAuthContext } from './context/AuthContext';
import { SessionExpiredModal } from './components/auth/SessionExpiredModal';
import { ThemeProvider } from './context/ThemeContext';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// Componente interno para acceder al contexto de auth
function AppWithAuth() {
  const { isSessionExpired, setSessionExpired } = useAuthContext();

  return (
    <>
      <App />
      <SessionExpiredModal
        isOpen={isSessionExpired}
        onClose={() => setSessionExpired(false)}
      />
    </>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <Auth0ProviderWithNavigate>
          <AuthProvider>
            <AuthTokenSync>
              <QueryClientProvider client={queryClient}>
                <AppWithAuth />
                <Toaster
                  position="top-right"
                  toastOptions={{
                    duration: 4000,
                    style: {
                      background: '#1e293b',
                      color: '#f8fafc',
                      border: '1px solid #334155',
                    },
                    success: {
                      iconTheme: {
                        primary: '#eab308',
                        secondary: '#f8fafc',
                      },
                    },
                    error: {
                      iconTheme: {
                        primary: '#ef4444',
                        secondary: '#f8fafc',
                      },
                    },
                  }}
                />
              </QueryClientProvider>
            </AuthTokenSync>
          </AuthProvider>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
